<template>
    <div class="video-content-page">
        <div class="video-content-container">
            <h1 class="video-title">{{ productInfo.name || 'Video' }}</h1>

            <div class="player-wrap" v-if="!loading && videoURL">
                <video class="video-player" :src="videoURL" :poster="productInfo.coverURL" controls preload="metadata"></video>
            </div>

            <div class="empty-tip" v-else-if="!loading">
                {{ $t('products.noData') }}
            </div>
    </div>
    </div>
</template>

<script>
import { getWebProductContent } from '@/api/editProducts'

export default {
  data () {
    return {
      productInfo: {},
      videoURL: '',
      loading: true
    }
  },
  mounted () {
    document.documentElement.scrollTop = 0
    this.getVideoContent(this.$route.params.slug)
  },
  watch: {
    '$route.params.slug' (slug) {
      this.getVideoContent(slug)
    }
  },
  methods: {
    getVideoContent (id) {
      this.loading = true
      this.productInfo = {}
      this.videoURL = ''
      if (!id) {
        this.loading = false
        return
      }
      getWebProductContent(id).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          this.productInfo = data
          this.videoURL = data.videoURL || ''
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.video-content-page {
    width: 100%;
    padding: 24px 12px 32px;
    box-sizing: border-box;
}

.video-content-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
}

.video-title {
    font-size: clamp(24px, 4vw, 38px);
    font-weight: 700;
    margin: 0 0 16px;
}

.player-wrap {
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #000;
    border-radius: 10px;
    overflow: hidden;
}

.video-player {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
}

.empty-tip {
    padding: 24px 0;
    color: #909399;
    font-size: 18px;
    text-align: center;
}

@media (max-width: 767.98px) {
    .video-content-page {
        padding: 14px 12px 24px;
    }

    .video-title {
        margin-bottom: 10px;
    }
}
</style>
